module.exports = __webpack_public_path__ + "img/汉熵流媒体管理平台.8d115b25.png";